import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    Self,
} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import {
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-input-dropdown-group',
    templateUrl: './input-dropdown-group.component.html',
    styleUrl: './input-dropdown-group.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
})
export class InputDropdownGroupComponent implements ControlValueAccessor, OnInit {
    @Input({required: true}) data!: ReadonlyMap<string | number, string>;
    @Input() id = '';
    @Input() placeholder = '';

    protected currentValue: string | number | null = null;
    protected isDisabled = false;

    private onChange: ((value: string | number | null) => void) | undefined;
    private onTouched: (() => void) | undefined;

    constructor(
        @Self() public readonly ngControl: NgControl,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
        ngControl.valueAccessor = this;
    }

    get selectedLabel(): string | undefined {
        return this.currentValue != null ? this.data.get(this.currentValue) : undefined;
    }

    ngOnInit(): void {
        if (this.ngControl.control != null) {
            const originalMarkAsTouched = this.ngControl.control.markAsTouched.bind(
                this.ngControl.control,
            );
            const changeDetectorRef = this.changeDetectorRef;
            this.ngControl.control.markAsTouched = function (...args): void {
                originalMarkAsTouched.apply(this, args);
                changeDetectorRef.detectChanges();
            };
        }
    }

    protected select(value: string | number): void {
        this.currentValue = value;
        this.onChange?.(value);
        this.changeDetectorRef.markForCheck();
    }

    protected markAsTouched(): void {
        this.onTouched?.();
    }

    registerOnChange(fn: (value: string | number | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(value: string | number | null): void {
        this.currentValue = value;
        this.changeDetectorRef.markForCheck();
    }

    setDisabledState(disabled: boolean): void {
        this.isDisabled = disabled;
        this.changeDetectorRef.markForCheck();
    }
}
